import type { DOMConversionMap, DOMConversionOutput } from "lexical";
import { $applyNodeReplacement } from "lexical";
import type { JSX } from "react";
import type { BroadcastRange, SerializedBroadcastNode } from "./broadcast-node";
import { BroadcastNode, broadcastWords } from "./broadcast-node";

export class BroadcastNodeMui extends BroadcastNode {
  static getType(): string {
    return super.getType();
  }

  static clone(node: BroadcastNodeMui): BroadcastNodeMui {
    return new this(node.__range, node.__key);
  }

  static importJSON(serializedNode: SerializedBroadcastNode): BroadcastNodeMui {
    return new this(serializedNode.range);
  }

  exportJSON(): SerializedBroadcastNode {
    return super.exportJSON();
  }

  decorate(): JSX.Element {
    return <>{this.getDisplay()}</>;
  }

  static importDOM(): DOMConversionMap<HTMLSpanElement> | null {
    return {
      span: (element) => {
        const textContent = element.textContent;
        if (
          !textContent.startsWith("@") ||
          !broadcastWords.includes(textContent.substring(1) as BroadcastRange)
        ) {
          return null;
        }
        return {
          conversion: (): DOMConversionOutput => ({
            node: $createChatReferenceBroadcastNodeMui(textContent.substring(1)),
          }),
          priority: 0,
        };
      },
    };
  }
}

export function $createChatReferenceBroadcastNodeMui(range: string): BroadcastNode {
  if (!broadcastWords.includes(range as BroadcastRange)) {
    throw new Error(`Invalid range: ${range}. Must be one of ${broadcastWords.join(", ")}`);
  }

  return $applyNodeReplacement(new BroadcastNodeMui(range as BroadcastRange));
}
